module.exports = __webpack_public_path__ + "img/home.26eb4795.png";